import { dateOptionsShort } from 'constants/dateFormats';
import { CurrentEvent } from 'types/currentEvent';
import { Service } from 'types/service';

const serviceList = (services: Service[]) => {
  const serviceList = services.map((s) => {
    return `<b>${s.heading}</b>
${s.description}`;
  });
  return serviceList.join('\n');
};

export default function getNotification(whichNotification: string, d: CurrentEvent, context?: { taskTitle?: string }) {
  const eventDate = d.mainData.dateStart
    ? new Date(d.mainData.dateStart)?.toLocaleDateString([], dateOptionsShort)
    : '';
  const eventTitle = d.mainData.eventTitle;
  const eventType = d.mainData?.eventType?.name || 'Event';
  switch (whichNotification) {
    case 'Event Booked':
      return {
        subject: `Event Booked: ${eventTitle} ${eventDate} `,
        html: /* html */ `<b>${eventTitle}</b> on <b>${eventDate}</b> has been set to booked!
          <b>Event Type</b>: ${eventType} 
          <b>Services Booked</b>: 
          ${serviceList(d.services)}`
      };
    case 'Client Portal Edits':
      return {
        subject: `Client Portal Updated: ${eventTitle} ${eventDate} `,
        html: /* html */ `<b>${eventTitle}</b> on <b>${eventDate}</b> has been updated by the client.
          <b>Event Type</b>: ${eventType}`
      };
    case 'Assigned To':
      return {
        subject: `You've been assigned a task for ${eventTitle} on ${eventDate}`,
        html: /* html */ `You have been assigned a task for <b>${eventTitle}</b> on <b>${eventDate}</b>.
          <b>Event Type</b>: ${eventType}
          <b>Task</b>: ${context?.taskTitle ?? '(no title)'}`
      };
    case 'Producer Set':
      return {
        subject: `You've been set as Producer for ${eventTitle} on ${eventDate}`,
        html: /* html */ `<b>${eventTitle}</b> on <b>${eventDate}</b> 
        <b>Event Type</b>: ${eventType} 
        <b>Services Booked</b>: 
        ${serviceList(d.services)}`
      };
    case 'Client Signed Contract':
      return {
        subject: `Contract Signed: ${eventTitle} ${eventDate}`,
        html: /* html */ `The client has signed the contract for <b>${eventTitle}</b> on <b>${eventDate}</b>.
          <b>Event Type</b>: ${eventType}
          Please review and countersign at your earliest convenience.`
      };
    case 'Test':
      return {
        subject: `A notification for ${d.mainData.eventTitle} on ${eventDate}`,
        html: /* html */ `Lorizzle ipsizzle dolizzle boom shackalack amizzle, 
        
        fizzle fo shizzle
        elit. Nullizzle sapizzle velizzle, shit volutpizzle, suscipit quizzle, gravida vel, yo
        mamma. Pellentesque for sure pizzle. Sed erizzle. Fusce own yo' crackalackin dapibus turpis
        tempizzle mofo. Mauris pellentesque fo shizzle away turpizzle. Fizzle izzle tortor.
        Pellentesque fo shizzle daahng dawg i'm in the shizzle.`
      };

    default:
      return {
        subject: 'Test Notification',
        html: `Lorizzle ipsizzle.`
      };
  }
}
